import type { SplitTestVariant, SystemSplitTestKey } from 'autogen/swagger/all';
import useUserContext from './useUserContext';

/**
 * A hook that returns the value(control / variant) of the current splitTestKey specified.
 * Returns undefined if the specified splitTestKey does not exist in the splitTestAssignments
 */
export default function useSplitTestValue(SplitTestKey: SystemSplitTestKey): undefined | SplitTestVariant {
    const { splitTestAssignments } = useUserContext();

    const splitTestValue = splitTestAssignments?.find((splitTest) => splitTest.splitTestKey === SplitTestKey);

    return splitTestValue?.variant;
}
